import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

/**
 * 첫 화면(/) — ver2(gold) 는 인트로 영상 없이 바로 메인으로 보낸다.
 *   기기에 따라 PC /main · 모바일 /m.
 */
export default function Intro() {
  const navigate = useNavigate()
  const isMobile = useMediaQuery({ maxWidth: 850 })

  useEffect(() => {
    navigate(isMobile ? '/m' : '/main', { replace: true })
  }, [isMobile])

  return null
}
